const menuList = [
    {
        id: 1,
        name: '非遗项目',
        formId: 'cultural_heritage_project',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '57ed207dcf924429c45100c202c62142651c83312c7ae7d68a7aa7777892039a5066948fb3dc970fc240392e22722d5c',
        type: ['人类级', '国家级', '省级', '州级', '县（市）级'],
        icon: require('@/assets/mapv2/331112/icon-point2.png'),
        compt: 'level',
        menu: [
            { id: 0, label: '简介', compt: '112,thumb' },
            { id: 2, label: '关联传承人', compt: 'identifier' },
            { id: 3, label: '相关图片', compt: 101 },
            { id: 4, label: '相关视频', compt: 102 },
            { id: 5, label: '相关音频', compt: 103 }
        ],
        editAlias: ['title', 'number'],
        editFormId: 1938374
    },
    {
        id: 2,
        name: '非遗传承人',
        formId: 'cultural_heritage_inheritor',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '57ed207dcf924429c45100c202c62142273459422eab738a2ef4681ff0d1e276d794a6b905f0918f3df30b1ce38395ba',
        type: ['人类级', '国家级', '省级', '州级', '县（市）级'],
        icon: require('@/assets/mapv2/331112/icon-point1.png'),
        compt: 'level',
        menu: [
            { id: 0, label: '简介', compt: '73,thumb' },
            { id: 1, label: '关联项目', compt: 59 },
            { id: 3, label: '相关图片', compt: 62 },
            { id: 4, label: '相关视频', compt: 65 },
            { id: 5, label: '相关音频', compt: 66 }
        ],
        editAlias: ['name', 'number'],
        editFormId: 1938373
    },
    {
        id: 3,
        name: '游学路线',
        icon: require('@/assets/mapv2/331112/icon-point3.png'),
        menu: [
            { id: 0, label: '简介', compt: 'introduce' },
            { id: 3, label: '相关图片', compt: 'banner' },
            { id: 4, label: '相关视频', compt: 'video' },
            { id: 5, label: '相关音频', compt: 'audio' }
        ]
    },
    {
        id: 4,
        name: '旅游景区',
        formId: '1955887',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '38f86691d445110e3bb6cf0f37e7d254f9bc01ec887c892376d2f19e46237588',
        icon: require('@/assets/mapv2/331112/icon-point4.png'),
        menu: [
            { id: 0, label: '简介', compt: '112,thumb' },
            { id: 4, label: '相关视频', compt: 'video' }
        ],
        editAlias: ['title', 'number'],
        editFormId: 1955887
    },
    {
        id: 5,
        name: '数字非遗馆',
        formId: '1061467',
        page: 1,
        limit: 100,
        searchStr: '',
        t: 'dc880beabb17500da1b4cc76249c8aa4f9bc01ec887c892376d2f19e46237588',
        icon: require('@/assets/mapv2/331112/icon-point5.png'),
        clink: 'detailUrl',
        editAlias: ['title', '1']
    },
    {
        id: 6,
        name: '文化空间',
        formId: '1061464',
        page: 1,
        limit: 100,
        searchStr: '',
        t: 'dc880beabb17500da1b4cc76249c8aa46734102c52770ead09fa755f4d7e341b',
        type: ['中国传统村落', '中国少数民族特色村寨', '民间文化艺术之乡', '全国乡村旅游重点村', '文化馆', '博物馆', '图书馆', '体育馆'],
        icon: require('@/assets/mapv2/331112/icon-point6.png'),
        compt: 'type',
        menu: [
            { id: 0, label: '简介', compt: 'introduction,venueCover' },
            { id: 3, label: '相关图片', compt: 'venueImg' },
            { id: 4, label: '相关视频', compt: 72 }
        ],
        editAlias: ['venueName', 'identifier'],
        editFormId: 1938372
    },
    {
        id: 7,
        name: '物质文化遗产',
        children: [
            {
                id: 71,
                name: '可移动文物',
                formId: '1939159',
                page: 1,
                limit: 100,
                searchStr: '',
                t: '40165b26d289163e4cb5560a843524c91838e364615b9ea94f1161c5b1664675',
                icon: require('@/assets/mapv2/331112/icon-point7.png'),
                menu: [
                    { id: 0, label: '简介', compt: 'digest,cover' }
                ],
                editAlias: ['title', 'identifier'],
                editFormId: 1939159
            },
            {
                id: 72,
                name: '不可移动文物',
                formId: '1939165',
                page: 1,
                limit: 100,
                searchStr: '',
                t: 'ff3658c8e83b272c85944f656536fb2f0b24954a46827574c4a07d6218162bb6',
                icon: require('@/assets/mapv2/331112/icon-point7.png'),
                menu: [
                    { id: 0, label: '简介', compt: 'digest,cover' }
                ],
                editAlias: ['title', 'identifier'],
                editFormId: 1939165
            }
        ]
    },
    {
        id: 8,
        name: '传承基地（传习所/点）',
        formId: '1959002',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '07461ea145195676b23373a8291110ab62ff15ea5556de6e783e8340f3f51f17',
        icon: require('@/assets/mapv2/331112/icon-point8.png'),
        menu: [
            { id: 0, label: '简介', compt: '12' },
            { id: 3, label: '相关图片', compt: 25 }
        ],
        editAlias: ['title', '1'],
        editFormId: 1959002
    },
    {
        id: 9,
        name: '非遗工坊',
        formId: '1958986',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '6af466de80b9807b5ffbf6ba4700afb483825a93035ae6268d91df56c28f60d9',
        icon: require('@/assets/mapv2/331112/icon-point9.png'),
        menu: [
            { id: 0, label: '简介', compt: '12' },
            { id: 3, label: '相关图片', compt: 25 }
        ],
        editAlias: ['title', '1'],
        editFormId: 1958986
    },
    {
        id: 10,
        name: '自然资源',
        formId: '1123245',
        page: 1,
        limit: 100,
        searchStr: '',
        t: '00faa90a91be3f45e771af3e18ece84e0b24954a46827574c4a07d6218162bb6',
        type: ['世界地质公园', '国家湿地公园', '风景名胜区', '国家森林公园', '国家级自然保护区'],
        icon: require('@/assets/mapv2/331112/icon-point10.png'),
        compt: 'type',
        menu: [
            { id: 0, label: '简介', compt: 'digest,cover' }
        ],
        editAlias: ['title', 'identifier'],
        editFormId: 1938378
    }
]

const pData = {
    menuList: menuList,
}

export default pData